import Button from "@mui/material/Button";
import Icon from "../../../../../../icons/main";
import { ToggleButtonType } from "./toggle.types";
import { Box, Typography } from "@mui/material";
import { Tooltip } from "../../../../../../modules/molecules/mui/main";
import { useState } from "react";
const ToggleButton = ({
  onClick,
  sidePanelOpen,
  disabled,
}: ToggleButtonType) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (!sidePanelOpen) setOpen(true);
  };
  return (
    <Tooltip
      title="expand"
      placement="right"
      arrow
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      sx={{ width: "1rem" }}
    >
      <Button
        sx={{
          width: "20%",
          marginBottom: "2rem",
          "&:hover": { backgroundColor: "transparent" },
          textTransform: "none",
        }}
        onClick={(event) => {
          onClick(event);
          setOpen(false);
        }}
        disabled={disabled}
        disableRipple
        disableFocusRipple
        disableElevation
        data-tut="toggle-btn"
      >
        {sidePanelOpen ? (
          <Box sx={{ display: "flex", gap: "0.25rem", alignItems: "center" }}>
            {Icon["collapse"]({
              width: { xs: "2rem" },
              height: { xs: "2rem" },
              color: "#000000",
            })}
            <Typography
              sx={{ fontSize: "0.875rem", fontWeight: "500", color: "black" }}
            >
              Collapse
            </Typography>
          </Box>
        ) : (
          Icon["expand"]({
            width: { xs: "2rem" },
            height: { xs: "2rem" },
            color: "#000000",
          })
        )}
      </Button>
    </Tooltip>
  );
};
export default ToggleButton;
